import TemplateView from "../TemplateView"
import ProjectStore from "../store/ProjectStore"
import CustomerStore from "../store/CustomerStore"
import $ from "jquery"
import _ from "underscore"
import LoadingControlMixin from "../controls/LoadingControlMixin"
import {nameComparator} from "../atUtils"
import SimpleTooltip from '../SimpleTooltip'
import BlockedTasksList from '../cptManagement/deleteConfirmationDialog/BlockedTasksList'
import CPCombobox from '../taskManagement/components/CPCombobox'

export default class MoveToDialog extends TemplateView {
    constructor({
        mode,
        titleMessageKey,
        buttonMessageKey,

        onMoveCb = (customerId, projectId, settings) => {},
        onCancelCb = () => {},

        infoBlock = null,
        settingsBlock = null,
        selectedCustomer = null,
    }) {
        super()

        this.props = {
            mode,
            titleMessageKey,
            buttonMessageKey,
        }

        this.state = {
            showArchived: false,

            selectedProject: null,
            selectedCustomer: selectedCustomer,
            moveEnabled: false,

            projectsToMove: {},
            customersToMove: {},
        }

        this.components = {
            infoBlock,
            settingsBlock,
        }

        this.callbacks = {
            onMoveCb,
            onCancelCb,
        }

        this.onStatePropertyChanged('selectedCustomer', (selectedCustomer) => {
            if (!!selectedCustomer && this.projectsCombobox) {
                const projects = ProjectStore.getByCustomer(selectedCustomer.id)
                                             .filter((p) => this.state.projectsToMove[p.id] && (this.state.showArchived || !p.archived))
                                             .sort(nameComparator)
                this.setStateInternal({
                    selectedProject: projects.length === 1 ? projects[0] : null,
                })
                this.projectsCombobox.setState({
                    items: projects,
                    selectedItemId: !!this.state.selectedProject ? this.state.selectedProject.id : DEFAULT_COMBOBOX_ITEM_ID,
                })
            }
        })

        this.onAnyStatePropertyChanged(['selectedProject', 'selectedCustomer'], () => {
            const moveEnabled = !!this.state.selectedCustomer && (this.props.mode === MoveToDialog.Mode.CUSTOMER || !!this.state.selectedProject)
            this.getEl().toggleClass("actionEnabled", moveEnabled)

            this.setStateInternal({
                moveEnabled,
            })

            this.customersCombobox.setState({
                selectedItemId: !!this.state.selectedCustomer ? this.state.selectedCustomer.id : DEFAULT_COMBOBOX_ITEM_ID,
            })
            if (!!this.projectsCombobox)
                this.projectsCombobox.setState({
                    selectedItemId: !!this.state.selectedProject ? this.state.selectedProject.id : DEFAULT_COMBOBOX_ITEM_ID,
                })
        })

        this.onStatePropertyChanged('showArchived', (showArchived) => {
            if (this.projectsCombobox) {
                this.projectsCombobox.setState({
                    emptyListMessageKey: showArchived ? "task.list.move_to.no_projects" : "task.list.move_to.no_active_projects",
                })
            }
        })
    }

    templateHtml() {
        return "<div class='moveToDialog'>" +
               "  <div class='title'><%-titleMessageKey%></div>" +
               "  <div class='customer'>" +
               "    <div class='label'></div>" +
               "    <div class='selectorContainer'></div>" +
               "  </div>" +
               "  <div class='points'/>" +
               "  <div class='project'>" +
               "    <div class='label'></div>" +
               "    <div class='selectorContainer'></div>" +
               "  </div>" +
               "  <div class='settingsBlockContainer'/>" +
               "  <div class='informationBlockContainer'/>" +
               "  <div class='blockedWarningContainer'>" +
               "      <div class='link'><%-warningLinkText%></div>" +
               "      <div class='other'><%-warningCommentText%></div>" +
               "  </div>" +
               "  <div class='buttonsContainer'>" +
               "    <div class='ok button'><%=moveLabel%></div>" +
               "    <div class='cancel button'><%=cancelLabel%></div>" +
               "  </div>" +
               "</div>"
    }

    messageKeys() {
        return {
            titleMessageKey: this.props.titleMessageKey,
            customerLabel: "common.Customer",
            projectLabel: "common.Project",
            moveLabel: this.props.buttonMessageKey,
            cancelLabel: "common.cancel",
            warningLinkText: "task.list.move_to.bulk.warning.link_text",
            warningCommentText: "task.list.move_to.bulk.warning.comment_text",
        }
    }

    afterRender() {
        this.$title = this.find('.title')
        this.$blockedWarningContainer = this.find('.blockedWarningContainer')
        this.$blockedWarningLink = this.find(".blockedWarningContainer .link")

        this.customersCombobox = new CPCombobox({
            emptySelectionMessageKey: "task.list.move_to.select_customer",
            notFoundMessageKey: "task.list.move_to.no_customers_found",
            hiddenItemsCollapsedMessageKey: 'task.list.move_to.show_archived_customers',
            hiddenItemsExpandedMessageKey: 'task.list.move_to.hide_archived_customers',
            emptyListMessageKey: "task.list.move_to.no_customers",
            onItemSelectedCb: (item) => {
                this.customersCombobox.setState({selectedItemId: item.id})
                this.setState({selectedCustomer: item})
            },
        }).init(this.find(".customer .selectorContainer"))

        this.find(".points").toggle(this.props.mode === MoveToDialog.Mode.CUSTOMER_PROJECT)
        if (this.props.mode === MoveToDialog.Mode.CUSTOMER_PROJECT) {
            this.getEl().addClass("hasProject")

            this.projectsCombobox = new CPCombobox({
                emptySelectionMessageKey: "task.list.move_to.select_project",
                notFoundMessageKey: "task.list.move_to.no_projects_found",
                emptyListMessageKey: "task.list.move_to.no_projects",
                hiddenItemsCollapsedMessageKey: 'task.list.move_to.show_archived_projects',
                hiddenItemsExpandedMessageKey: 'task.list.move_to.hide_archived_projects',
                onItemSelectedCb: (item) => {
                    this.projectsCombobox.setState({selectedItemId: item.id})
                    this.setState({selectedProject: item})
                },
            }).init(this.find(".project .selectorContainer"))
        }

        this.find(".ok.button").click(() => {
            if (this.state.moveEnabled) {
                $(this).trigger("move", {
                    projectId: this.state.selectedProject,
                    customerId: this.state.selectedCustomer,
                })
                this.callbacks.onMoveCb(
                    this.state.selectedCustomer,
                    this.state.selectedProject ? this.state.selectedProject : null,
                    this.components.settingsBlock ? this.components.settingsBlock.getSelectedSettings() : null
                )
            }
        })

        this.find(".cancel.button").click(() => {
            $(this).trigger("cancel")
            this.callbacks.onCancelCb()
        })

        this.$settingsBlockContainer = this.find('.settingsBlockContainer')
        this.$settingsBlockContainer.toggle(!!this.components.settingsBlock)
        if (this.components.settingsBlock) {
            this.components.settingsBlock.init(this.$settingsBlockContainer)
        }

        this.$informationBlockContainer = this.find('.informationBlockContainer')
        this.$informationBlockContainer.toggle(!!this.components.infoBlock)
        if (this.components.infoBlock) {
            this.components.infoBlock.init(this.$informationBlockContainer)
        }

        this.renderInitialState()
    }

    show() {
        super.show()
        this.updateSelector()
    }

    updateSelector() {
        this.setState({
            selectedProject: null,
        })

        const customers = CustomerStore.getAll()
                                       .filter((c) => !!this.state.customersToMove[c.id] && (this.state.showArchived || !c.archived))
                                       .sort(nameComparator)


        this.customersCombobox.setState({
            items: customers,
        })
    }

    setShowArchived(showArchived) {
        this.setState({
            showArchived,
        })
    }

    setProjectsToMove(projectIds) {
        this.setState({
            projectsToMove: projectIds,
        })
    }

    setCustomersToMove(customerIds) {
        this.setState({
            customersToMove: customerIds,
        })
    }

    updateTitle(title) {
        this.$title.text(title)
    }

    updateNotAvailableTasks(tasks) {
        if (this.blockedEntitiesList) {
            this.blockedEntitiesList.setDisabled(true)
            this.blockedEntitiesList.getEl().remove()
        }
        this.$blockedWarningContainer.toggle(tasks.length !== 0)
        if (tasks.length !== 0) {
            this.blockedEntitiesList = new BlockedTasksList($("body"), tasks, 0).init()
            this.$blockedWarningLink.click(() => {
                if (!this.blockedEntitiesList.isDisabled())
                    this.blockedEntitiesList.showAt(this.$blockedWarningLink, {
                        offset: "10px 20px",
                        at: "right bottom",
                        my: "left bottom",
                        collision: "none"
                    })
            })
        }
    }
}

const DEFAULT_COMBOBOX_ITEM_ID = -1

_.extend(MoveToDialog.prototype, LoadingControlMixin)

MoveToDialog.Mode = {
    CUSTOMER_PROJECT: "CUSTOMER_PROJECT",
    CUSTOMER: "CUSTOMER"
}



// WEBPACK FOOTER //
// ./web/js/panels/MoveToDialog.js